import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApisService } from 'app/services/apis.service';
import { LoadingService } from 'app/services/loading.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-branches',
  templateUrl: './add-branches.component.html',
  styleUrls: ['./add-branches.component.scss']
})
export class AddBranchesComponent implements OnInit {
  entityForm: FormGroup;
  mediaForm : FormGroup
  imagePreview: string | null = null;
  isDisabled: boolean = true;
  countries: any
  mediaUrl : any
  
  entities:any
  selectedFile: File;
  mediaName : any

  constructor(private fb: FormBuilder,
    private apisService: ApisService ,
    private toastr :ToastrService,
    private loading :LoadingService, 
    private modal : NgbModal, 
    private router : Router
  ) {
    this.entityForm = this.fb.group({
 name: ['', [Validators.required, Validators.maxLength(20)]],
  minAge: [null, [Validators.required, Validators.min(0)]],
  maxAge: [null, [Validators.required, Validators.min(0)]]

    });
  }

  ngOnInit(): void {
  }

  
  /*----------  Uploading Media  ----------*/
  onFileSelected(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;
  
    // Update the form with the file name
    const filesArray = this.mediaForm.get('files') as FormArray;
    const fileGroup = filesArray.at(0) as FormGroup;
    fileGroup.patchValue({ name: file.name });
  
    // Preview the image
    const reader = new FileReader();
    reader.onload = () => {
      this.imagePreview = reader.result as string;
      this.isDisabled = false;
    };
    reader.readAsDataURL(file);

    // Optionally store the file itself for upload
    this.selectedFile = file;
    console.log(this.selectedFile);
  }
  
  
  /*----------  Zoom function  ----------*/
  zoom(content:any){
    this.modal.open(content, { size: 'lg' , centered : true  });
  }
  
addEntity(data:any){ 

  this.apisService.addGroupedAge(data).subscribe({
    next: (res) => {
      console.log("Successfully added ", res );

      this.toastr.success("Successfully added" , "Success");
      this.router.navigate(['/entities-list']);
    },
    error: (error) => {
      console.log("error ", error);

      this.toastr.error("Error in adding entity", error);
    },
  })
}

// submitting the form
 onSubmit() {
  if (this.entityForm.valid) {
    const payload = this.entityForm.value;
    console.log('Submitting:', payload);

    this.apisService.addBranches(payload).subscribe({
      next: (res) => {
        this.toastr.success("Group Age added successfully", "Success");
        this.router.navigate(['/group-ages']);
      },
      error: (err) => {
        this.toastr.error("Failed to add Group Age", "Error");
        console.error(err);
      }
    });
  } else {
    this.toastr.warning("Please fill all required fields correctly.", "Validation Error");
  }
}

/*----------  Reset Button  ----------*/
resetForm() {
  this.entityForm.reset();
}
  

}
